import { FoodName, StyledNameAndPortion } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import MyFoodIcon from "components/Icons/MyFood"
import { IMyFood, IMyMeal } from "model/food/types/myfood.types"
import MyFoodPortionUnitTextFormItem from "./MyFoodPortionUnitTextFormItem"
import {
  IAIScanMeal,
  IAIScanNutritionFactMeal,
  IAIScanPackageMeal,
} from "model/food/types/AIScan.types"
import FutureMealIcon from "components/Icons/FutureMealIcon"

interface IProps {
  food:
    | IMyFood
    | IMyMeal
    | IAIScanMeal
    | IAIScanPackageMeal
    | IAIScanNutritionFactMeal
  portionValue: number
  onPortionChange: (portion: number) => void
  unitValue: string
  onUnitChange: (unit: string) => void
  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
  gram: null | number
  isFutureScheduleMeal?: boolean
}

const MyFoodNameAndPortion = (props: IProps) => {
  const {
    food,
    onPortionChange,
    portionValue,
    unitValue,
    onUnitChange,
    disabled,
    setIsPortionValid,
    calories,
    gram,
    isFutureScheduleMeal,
  } = props

  return (
    <StyledNameAndPortion>
      <FlexBox
        $alignItems="center"
        $gap={8}
        style={{ padding: "4px 0", width: "100%" }}
      >
        <FoodName>{food.name} </FoodName>
        <MyFoodIcon
          style={{
            alignSelf: "flex-start",
            position: "relative",
            top: 4,
          }}
        />

        {isFutureScheduleMeal && <FutureMealIcon />}
      </FlexBox>

      <MyFoodPortionUnitTextFormItem
        unitValue={unitValue}
        portionValue={portionValue}
        onPortionChange={onPortionChange}
        onUnitChange={onUnitChange}
        setIsPortionValid={setIsPortionValid}
        calories={calories}
        disabled={disabled}
        gram={gram}
      />
    </StyledNameAndPortion>
  )
}

export default MyFoodNameAndPortion
